import React, { useState, useEffect } from 'react';
import OrderForm from './OrderForm'
import { useForm } from '../../hooks/useForm';
import { Grid } from '@material-ui/core';
import SearchFoodItems from './SearchFoodItems';
import OrderedFoodItems from './OrderedFoodItems';


const generateOrderNumber = () => Math.floor(100000 + Math.random() * 900000).toString();

const getFreshModelObject = () => ({
    orderMasterId: 0,
    orderNumber: generateOrderNumber(),
    customerId: 0,
    pMethod: 'none',
    gTotal: 0,
    deletedOrderItemIds: '',
    orderDetails: [],
    idalumno: 0,
    idusuario: 0,
    alias: '',
    factura: 'none',
    rfc: '',
    correo: '',
    iva: 'none',
    comision: 'none',
    subtotal: 0,
    valorIva: 0,
    valorComision: 0,
    ajuste: 0,
    tipoajuste: 'none',
    motivoajuste: '',
    nivelsiguienteciclo: 'none',
    gradosiguienteciclo: 'none',
    siguienteciclo: 'none',
    realizarinscripcion: 'none',
    transferencia:0,
    efectivo: 0,
    tarjetaDebito: 0,
    tarjetaCredito: 0,
    cheque: 0

})


export default function Order(props) {

    const {
        values,
        setValues,
        errors,
        setErrors,
        handleInputChange,
        resetFormControls
    } = useForm(getFreshModelObject);

    const [alumnoid, setAlumnoid] = useState(0);
    const [nombrealumno, setNombrealumno] = useState(0);
    const [gradoalumno, setGradoalumno] = useState('');
    const [nivelalumno, setNivelalumno] = useState(0);
    const [grupoalumno, setGrupoalumno] = useState('');
    const [correo2, setCorreo2] = useState('');

    useEffect(() => {
        //setCorreo(props.correo2);
        setAlumnoid(props.alumnoid);

        //console.log("---------id--*****>" + props.alumnoid);
        //console.log("---------Correo2--*****>" + props.correo2);
        //console.log("---------***>" + JSON.stringify(props));

    }, [props.alumnoid]);

    useEffect(() => {
        setNombrealumno(props.nombrealumno);
    }, [props.nombrealumno]);

    useEffect(() => {
        setGradoalumno(props.gradoalumno);
    }, [props.gradoalumno]);

    useEffect(() => {
        setNivelalumno(props.nivelalumno);
    }, [props.nivelalumno]);

    useEffect(() => {
        setGrupoalumno(props.grupoalumno);
    }, [props.grupoalumno]);
    

    useEffect(() => {
        //setCorreo(props.correo2);
        setCorreo2(props.correo2);
        //console.log("---------***>" + JSON.stringify(props));
    }, [props.correo2]);



    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <OrderForm
                    {...{
                        correo2,
                        alumnoid,
                        nombrealumno,
                        gradoalumno,
                        nivelalumno,
                        grupoalumno,
                        values,
                        setValues,
                        errors,
                        setErrors,
                        handleInputChange,
                        resetFormControls
                    }}
                />
            </Grid>

            <Grid item xs={6}>
                <SearchFoodItems
                    {...{
                        alumnoid,
                        values,
                        setValues
                    }}
                />
            </Grid>
            <Grid item xs={6}>
                <OrderedFoodItems
                    {...{
                        values,
                        setValues,
                        errors,
                        setErrors,
                        handleInputChange
                    }}
                />
            </Grid>
        </Grid>
    )
}
